import { Card, CardContent, PageHeader, Pagination, QueryErrorAlert } from '@/shared/components';
import { DocumentTemplatesDataTable } from '../components/DocumentTemplatesDataTable';
import { TemplateListToolbar } from '../components/TemplateList/TemplateListToolbar';
import { useDocumentTemplatesQuery } from '../hooks/useDocumentTemplatesQuery';
import { useTemplateListFilters } from '../hooks/useTemplateListFilters';

const TITLE_ID = 'all-templates-title';

export function DocumentTemplateList() {
  const list = useTemplateListFilters();
  const query = useDocumentTemplatesQuery(list.params);
  const meta = query.data?.meta;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Document templates"
        subtitle="Letters and certificates sent to customers, and the versions behind them."
      />
      <Card ariaLabelledBy={TITLE_ID}>
        <TemplateListToolbar titleId={TITLE_ID} total={meta?.total} list={list} />
        {query.isError ? (
          <CardContent>
            <QueryErrorAlert message="Could not load document templates. You may not have access, or the request failed." onRetry={() => query.refetch()} isRetrying={query.isFetching} />
          </CardContent>
        ) : (
          <>
            <DocumentTemplatesDataTable
              data={query.data?.templates ?? []}
              isLoading={query.isLoading}
              emptyMessage="No document templates found. Try adjusting your search or create a new template."
              sorting={list.sorting}
              onSortingChange={list.setSorting}
            />
            {meta && meta.lastPage > 1 && (
              <Pagination
                currentPage={meta.currentPage}
                lastPage={meta.lastPage}
                total={meta.total}
                perPage={meta.perPage}
                from={meta.from}
                to={meta.to}
                onPageChange={list.setPage}
                onPerPageChange={list.setPerPage}
              />
            )}
          </>
        )}
      </Card>
    </div>
  );
}
